module.exports = __webpack_public_path__ + "img/homepage-content-over-image-side-cjdr.a89559d7.png";